import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import history from '~/Providers/History';
import SkinWrapper from '~/Containers/Layout/SkinWrapper/SkinWrapper';
import DateTabs from '~/Components/Layout/DateTabs/DateTabs';

import MobileTrayItems from '~/Components/Global/MobileTray/MobileTrayItems';
import MobileFAB from '~/Components/Global/MobileTray/MobileFAB';
import config from '~/Config';
import OnboardingFAB from '~/Components/Global/Onboarding/OnboardingFAB';

const { heartbeatInterval } = config;

class Agenda extends Component {
  componentDidMount = () => {
    this.checkCalendars(this.props);
  };

  componentWillReceiveProps = next => {
    this.checkCalendars(next);
  };

  checkCalendars = props => {
    if (!props.isFetching && props.isFetched && !props.accounts) {
      history.push('/add-accounts'); // if the user has no accounts they cannot access the agenda pages
    }
  };

  render() {
    if (this.props.isFetching && !this.props.isFetched && !this.props.accounts) return false;
    const { currentDate, isHabit, streamsReady, onboardingComplete } = this.props;
    return (
      <SkinWrapper currentDate={currentDate} heartbeat={heartbeatInterval * 1000}>
        <DateTabs>{this.props.children}</DateTabs>
        <MobileTrayItems />
        <MobileFAB isHabit={isHabit} />
        {streamsReady && !onboardingComplete && <OnboardingFAB />}
      </SkinWrapper>
    );
  }
}

Agenda.propTypes = {
  children: propTypes.node,
  isFetching: propTypes.bool,
  isFetched: propTypes.bool,
  accounts: propTypes.number,
  currentDate: propTypes.object,
  isHabit: propTypes.bool,
  streamsReady: propTypes.bool,
  onboardingComplete: propTypes.bool,
};

const mapStateToProps = state => ({
  streamsReady: state.Onboarding.onboarding.streamsReady,
  onboardingComplete: state.UserOptions.data.onboarding_complete,
});

export default connect(mapStateToProps)(Agenda);
